module.exports = __webpack_public_path__ + "static/Apercu-Bold-20da237c936f6815ed972c284cfda35e.eot";